import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Card from "../assets/images/card.png";
import BankTransfer from "../assets/images/bankTransfer.png";
import PayPhone from "../assets/images/payPhone.png";
import InactiveCard from "../assets/images/card-light.png";
import ActiveBankTransfer from "../assets/images/banktransferActive.png";
import PhoneActive from "../assets/images/phoneActive.png";

const PaymentOptions = () => {
  const [showLinks, setShowLinks] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to "/card" when on the root route "/"
    if (location.pathname === "/") {
      navigate("/card");
    }
  }, [location.pathname, navigate]);

  const activeCardClass =
    "flex items-center gap-3 justify-center pl-12 rounded-r-[5px] py-[30px] h-[63px] w-[228px] bg-white border-solid border-l border-orangeCard text-orangeCard font-extrabold";
  const nonActiveCardClass =
    "flex items-center gap-3 justify-center pl-12 rounded-r-[5px] py-[30px] h-[63px] w-[228px] bg-white text-normalText font-semibold";
  const activeClass =
    "flex items-center gap-3 justify-center rounded-r-[5px] py-[30px] h-[63px] w-[228px] bg-white border-solid border-l border-orangeCard text-orangeCard font-extrabold";
  const nonActiveClass =
    "flex items-center gap-3 justify-center rounded-r-[5px] py-[30px] h-[63px] w-[228px] bg-white text-normalText font-semibold";

  const links = [
    {
      to: "/card",
      text: "Card",
      imageSource: Card,
      alternateImage: InactiveCard,
      activeClass: activeCardClass,
      nonActiveClass: nonActiveCardClass,
    },
    {
      to: "/transfer",
      text: "Pay by Transfer",
      imageSource: ActiveBankTransfer,
      alternateImage: BankTransfer,
      activeClass: activeClass,
      nonActiveClass: nonActiveClass,
    },
    {
      to: "/phone",
      text: "Pay with Phone",
      imageSource: PhoneActive,
      alternateImage: PayPhone,
      activeClass: activeClass,
      nonActiveClass: nonActiveClass,
    },
  ];

  return (
    <div className="container flex gap-40">
      <div className="mt-[219px] w-[427px]">
        <h1 className="text-xl font-semibold text-lightBlack pl-[221px]">
          Payment Options
        </h1>
        <div className="pl-[198.66px] mt-4">
          {links.map((link, index) => (
            <NavLink
              key={index}
              to={link.to}
              className={
                location.pathname === link.to ||
                location.pathname.startsWith(`${link.to}`)
                  ? link.activeClass
                  : link.nonActiveClass
              }
              end
              onClick={() => navigate(link.to)}
            >
              <p className="text-sm">{link.text}</p>
              <img
                src={
                  location.pathname === link.to ||
                  location.pathname.startsWith(`${link.to}`)
                    ? link.imageSource
                    : link.alternateImage
                }
                alt={link.text.toLowerCase()}
                className="w-[33px] h-[33px]"
              />
            </NavLink>
          ))}
        </div>
      </div>
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default PaymentOptions;
